import { render, staticRenderFns } from "./datasource-menu.vue?vue&type=template&id=b3a54b26&scoped=true&"
import script from "./datasource-menu.vue?vue&type=script&lang=ts&"
export * from "./datasource-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a54b26",
  null
  
)

export default component.exports